import {
  Vendor,
  FetchVendorsResponse,
  AddVendorResponse,
} from '../../../services'
import { ActionTypes, searchVendor } from '../actions'
import { BaseReducerState } from '../../../services/types'

export interface VendorList {
  data: Vendor[]
  searchResults: Vendor[]
  searchTerm: string
}

export interface VendorAdd {
  data: Vendor | null
}

export type VendorListState = BaseReducerState & VendorList
export type VendorAddState = BaseReducerState & VendorAdd
export type VendorManageState = {
  list: VendorListState
  add: VendorAddState
}

type SearchUpdate = {
  data: Vendor[]
  searchTerm: string
}

const initialState: VendorManageState = {
  list: {
    loading: false,
    success: false,
    message: '',
    data: [],
    searchResults: [],
    searchTerm: '',
  },
  add: {
    loading: false,
    success: false,
    message: '',
    data: null,
  },
}

export const manageVendors = (
  state: VendorManageState = initialState,
  action: {
    type: string
    res: FetchVendorsResponse | AddVendorResponse | SearchUpdate
  }
): VendorManageState => {
  switch (action.type) {
    case `${ActionTypes.FETCH_VENDORS}_REQUEST`:
      return {
        ...state,
        list: {
          ...state.list,
          loading: true,
          success: false,
          message: null,
        },
      }

    case `${ActionTypes.FETCH_VENDORS}_SUCCESS`: {
      const { success, data, message } = <FetchVendorsResponse>action.res
      const searchResults = searchVendor(state.list.searchTerm, data || [])
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          success,
          message,
          searchResults,
          ...(success && data && { data: data }),
        },
      }
    }

    case `${ActionTypes.VENDOR_SEARCH_RESULTS}`: {
      const { data, searchTerm } = <SearchUpdate>action.res
      return {
        ...state,
        list: {
          ...state.list,
          searchResults: data,
          searchTerm,
        },
      }
    }

    case `${ActionTypes.FETCH_VENDORS}_FAILURE`: {
      const { message } = <FetchVendorsResponse>action.res
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          success: false,
          message: message,
        },
      }
    }
  }
  return state
}
